import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./theme-dark.css";

// Ultimate fallback error handler for catastrophic failures
// Uses DOM API instead of innerHTML for security best practices
const showFallbackError = () => {
  // Clear body content safely
  while (document.body.firstChild) {
    document.body.removeChild(document.body.firstChild);
  }

  // Create container
  const container = document.createElement("div");
  container.style.cssText = "min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;font-family:system-ui,sans-serif;background:#f5f5f5;";

  // Create inner wrapper
  const wrapper = document.createElement("div");
  wrapper.style.cssText = "text-align:center;max-width:400px;";

  // Create heading
  const heading = document.createElement("h1");
  heading.style.cssText = "color:#333;margin-bottom:16px;";
  heading.textContent = "Unable to Load App";

  // Create message paragraph
  const message = document.createElement("p");
  message.style.cssText = "color:#666;margin-bottom:24px;";
  message.textContent = "Please try clearing your browser cache and refreshing.";

  // Create button
  const button = document.createElement("button");
  button.style.cssText = "background:#8b5cf6;color:white;border:none;padding:12px 24px;border-radius:8px;cursor:pointer;font-size:16px;";
  button.textContent = "Clear Cache & Reload";
  button.addEventListener("click", () => {
    localStorage.clear();
    sessionStorage.clear();
    location.reload();
  });

  // Assemble DOM
  wrapper.appendChild(heading);
  wrapper.appendChild(message);
  wrapper.appendChild(button);
  container.appendChild(wrapper);
  document.body.appendChild(container);
};

const renderApp = () => {
  try {
    const container = document.getElementById("root");
    if (!container) {
      throw new Error("Root element not found");
    }
    createRoot(container).render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );
  } catch (error) {
    console.error("Critical render error:", error);
    // Show minimal error UI if React completely fails using safe DOM methods
    showFallbackError();
  }
};

renderApp();
